import {Navigate, Route, Routes, Outlet, useParams, useSearchParams} from 'react-router-dom'
import { DefaultTitle } from '../../../../_metronic/layout/components/header/page-title/DefaultTitle'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { Article } from '../share-components/Article'
import { EmailConfirmation } from '../verification/EmailConfirmation'
import { ResetPassword } from '../verification/ResetPassword'
import { Overview } from './components/Overview'
import { Settings } from './components/settings/Settings'
import { Home } from './Home'

const HomePage = () => {

  var devBreadCrumbs: Array<PageLink> = [
    {
      title: 'หน้าหลัก',
      path: '/home',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const [queryParameters] = useSearchParams()
  
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='article'
          element={
            <>
              <PageTitle breadcrumbs={devBreadCrumbs}>{queryParameters.get("doc_type") ? 'รายละเอียด'+queryParameters.get("doc_type"): 'รายละเอียด'}</PageTitle>
              <DefaultTitle />
              <Article />
            </>
          }
        />
        <Route
          path='email_confirm'
          element={
            <>
              <DefaultTitle />
              <EmailConfirmation />
            </>
          }
        />
        <Route
          path='password_reset'
          element={
            <>
              <DefaultTitle />
              <ResetPassword />
            </>
          }
        />
        <Route
          path='/account/overview'
          element={
            <>
              <PageTitle breadcrumbs={devBreadCrumbs}>โปรไฟล์ของคุณ</PageTitle>
              <DefaultTitle />
              <Overview />
            </>
          }
        />
        <Route
          path='/account/settings'
          element={
            <>
              <PageTitle breadcrumbs={devBreadCrumbs}>ตั้งค่าโปรไฟล์</PageTitle>
              <DefaultTitle />
              <Settings />
            </>
          }
        />
        <Route index element={<Home />} />
      </Route>
    </Routes>
  )
}

export default HomePage
